import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { Grid, Box, TextField, Divider, Button, LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { AccountBox, Keyboard } from '@material-ui/icons';

import './Login.css';
import logo from '../images/logo2.png';
import { loginRequest } from '../actions/authorizeAction';

const useStyles = makeStyles(() => ({
    logo: {
        width: 'auto',
        height: 'auto',
        marginLeft: -40,
        borderRadius: 15,
        backgroundColor: '#fafafa',
        position: 'relative',
        '&:after': {
            content: '""',
            position: 'absolute',
            marginLeft: 20,
            top: '50%',
            backgroundColor: 'grey',
            height: 2,
            width: 'auto'
        }
    },
    form: {
        fontSize: '1.1rem',
        //        fontWeight: 'bold',
        paddingTop: '0.5rem'
    }
}));

function Login() {
    const style = useStyles();
    const authorize = useSelector(state => state.authorize);
    const dispatch = useDispatch();
    const [error, setError] = useState({});
    const [loginInfo, setLoginInfo] = useState({
        id: '',
        password: ''
    });

    useEffect(() => {
        if (authorize.status === 3) {
            if (authorize.error) {
                setError({ id: authorize.error });
            }
        }

    }, [authorize]);

    if (authorize.status === 2) {
        return (<Redirect to={`/`} />)
    }


    const onInputChange = (event) => {
        setLoginInfo({ ...loginInfo, [event.target.id]: event.target.value });
        setError({ ...error, [event.target.id]: '' });
    }

    const checkLogin = (event) => {

        event.preventDefault();

        var err = undefined;
        if (!loginInfo.id)
            err = { ...err, id: '使用者帳號不可空白 !' };
        if (!loginInfo.password)
            err = { ...err, password: '密碼不可空白 !' };

        if (err) {
            setError(err);
            return;
        }

        dispatch(loginRequest(loginInfo));
    }

    return (
        <>
            <Grid container direction="row" justify="flex-end">
                <Grid item>
                    <Box borderRadius={15} m={5} p={2} pr={3} bgcolor="grey.200" boxShadow={5} width={380}>
                        <Box fontSize="h5.fontSize" textAlign="right">
                            登入
                    </Box>
                        <Box pl={1} pt={2}>
                            <img src={logo} alt="logo" />
                        </Box>

                        <Divider style={{ marginTop: -10, height: 2 }} />
                        <Box pt={6} display="flex" alignItems="flex-end">
                            <Box ml={3} mr={1}>
                                <AccountBox style={{ fontSize: 42 }} />
                            </Box>
                            <Box mr={3}>
                                <TextField margin='dense' fullWidth id="id" error={!!error.id} label="使用者帳號" onChange={onInputChange}
                                    InputLabelProps={{ classes: { root: style.form } }} disabled={authorize.status === 1}
                                    InputProps={{ classes: { root: style.form } }} helperText={error.id}
                                />
                            </Box>
                        </Box>
                        <Box pt={2} display="flex" alignItems="flex-end">
                            <Box ml={3} mr={1}>
                                <Keyboard style={{ fontSize: 42 }} />
                            </Box>
                            <Box mr={3}>
                                <TextField margin='dense' fullWidth id="password" error={!!error.password} label="密碼" onChange={onInputChange}
                                    InputLabelProps={{ classes: { root: style.form } }} disabled={authorize.status === 1}
                                    InputProps={{ classes: { root: style.form, } }} type='password' helperText={error.password}
                                />
                            </Box>
                        </Box>
                        {authorize.status === 1 ?
                            <Box pt={2} display="flex" alignItems="center">
                                <LinearProgress color="secondary" style={{ width: '100%' }} />
                            </Box> : null}
                        <Box p={5} pt={3} pb={2} justifyContent="flex-end" display="flex">
                            <Box>
                                <Button size="large" variant="contained" color="primary" classes={{ root: style.form }} disabled={authorize.status === 1} onClick={checkLogin}>
                                    登&nbsp;&nbsp;&nbsp;入
                            </Button>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid >
            <Box display="flex" width="100%" bgcolor="rgba(200, 200, 200, 0.8)" style={{ position: 'absolute', margin: "auto", bottom: 0, zIndex: -1 }}>
                <Box pl={10} flexGrow={1}>
                    Copyright ©SolarBank 2020. All Right Reserved.
                        </Box>
                <Box pr={10}>
                    Image credit: AwesomWallpaper
                        </Box>
            </Box>
        </>
    );

}

export default Login;